import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Component({
  selector: 'app-clear-cache-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clear-cache-modal.component.html',
  styleUrls: ['./clear-cache-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClearCacheModalComponent {
  isOpen = false;
  isRunning = false;
  isDone = false;
  showProgress = false;

  steps = { storage: false, cookies: false, caches: false, reload: false };

  constructor(private router: Router) {}

  open()  { this.isOpen = true; }
  close() { if (!this.isRunning) this.isOpen = false; }

  onBackdropClick(e: MouseEvent) {
    if ((e.target as HTMLElement).classList.contains('cache-modal-backdrop')) this.close();
  }

  async runClear(): Promise<void> {
    this.isRunning = true;
    this.showProgress = true;

    try { localStorage.clear(); sessionStorage.clear(); } catch {}
    await this.delay(450);
    this.steps.storage = true;

    try {
      document.cookie.split(';').forEach(cookie => {
        const name = cookie.split('=')[0].trim();
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
    } catch {}
    await this.delay(450);
    this.steps.cookies = true;

    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(key => caches.delete(key)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
      }
    } catch {}
    await this.delay(450);
    this.steps.caches = true;

    await this.delay(300);
    this.steps.reload = true;
    this.isRunning = false;
    this.isDone = true;

    await this.delay(800);

    // Clear auth
    document.cookie = `AuthToken=bar; expires=0; domain=.singsnap.com`;
    Cookie.deleteAll();
    localStorage.removeItem('token');

    await this.router.navigate(['/login']);
    window.location.reload();
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
